<app-page-heading
  pageTitle="rData Aggregates"
  pageDescription="View key data points across various percentiles."
></app-page-heading>

<app-rdata-aggregates> </app-rdata-aggregates>

<lib-alert
  class="cta-alert"
  type="info"
  [centerContent]="true"
  [dismissible]="false"
  [show]="true"
  [showIcon]="true"
>
  <span
    >Contact your sales representative to unlock additional specialties and
    regions.</span
  >
</lib-alert>
